import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient} from '@angular/common/http'
import { ProtocoloComponent } from '../../_components/protocolo/protocolo.component';
import { MatDialog } from '@angular/material/dialog';
import { Message } from '../../_models/Message';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {
  @ViewChild('file', {static: true}) file: ElementRef;
  public progress: number;
  public message: string;
  formData: FormData;
  mineTypes: string[] = ['image/gif', 'image/png', 'image/jpeg', 'application/pdf', 'image/tiff'];
  constructor(private http: HttpClient,
              private protocolo: ProtocoloComponent,
              private dialog?: MatDialog) { 
    this.formData = new FormData();
  }

  loadFiles() {
    var files = this.file.nativeElement.files;
    if (files.length === 0)
      return;

    for (let file of files) {
      let mine = this.mineTypes.find(c => c == file.type);
      if(!mine) {
        let msg =  new Message("Atenção",'A imagem do documento deve estar nos formatos ".png", "gif", ".tif", ".jpg" ou ".pdf"', "", "error");
        this.dialog.open(PopupMessagesNewStyleTestComponent, {data: msg});
        return;
      }

      this.formData.append(file.name, file);
      this.protocolo.FormDataUpload.append(file.name, file);
      this.protocolo.LstUploadFiles.push(file.name);
    }
  }

  removeFile(fileParam){
    for (let file of this.file.nativeElement.files) {
      if (file.name == fileParam.name)
        this.file.nativeElement.files = this.file.nativeElement.files.filter(obj => obj !== fileParam);
    }
  }

  ngOnInit() {
  }
}
